"use client"

import * as CollapsiblePrimitive from "@radix-ui/react-collapsible"
import type { ReactNode, Dispatch, SetStateAction } from "react"

interface CollapsibleProps {
  children?: ReactNode
  open?: boolean
  defaultOpen?: boolean
  onOpenChange?: Dispatch<SetStateAction<boolean>> | ((open: boolean) => void)
  disabled?: boolean
  className?: string
}

interface CollapsibleTriggerProps {
  children?: ReactNode
  asChild?: boolean
  className?: string
}

interface CollapsibleContentProps {
  children?: ReactNode
  forceMount?: true
  className?: string
}

function Collapsible({
  children,
  ...props
}: Readonly<CollapsibleProps>) {
  return (
    <CollapsiblePrimitive.Root data-slot="collapsible" {...props}>
      {children}
    </CollapsiblePrimitive.Root>
  )
}

function CollapsibleTrigger({
  children,
  ...props
}: Readonly<CollapsibleTriggerProps>) {
  return (
    <CollapsiblePrimitive.CollapsibleTrigger
      data-slot="collapsible-trigger"
      {...props}
    >
      {children}
    </CollapsiblePrimitive.CollapsibleTrigger>
  )
}

function CollapsibleContent({
  children,
  ...props
}: Readonly<CollapsibleContentProps>) {
  return (
    <CollapsiblePrimitive.CollapsibleContent
      data-slot="collapsible-content"
      {...props}
    >
      {children}
    </CollapsiblePrimitive.CollapsibleContent>
  )
}

export { Collapsible, CollapsibleTrigger, CollapsibleContent }
